import React from 'react';
import { Link } from 'react-router-dom';

const VoiceAndSMSRecords = (props) => {
  const {
    sub,
    title,
    error,
    success,
    redirectionLink,
    saveStatus,
    onSubmitVoice,
    onSubmitSMS,
    SubNav,
    TableComponent,
  } = props;

  if (!sub) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>{title}</h1>
      <article>
        <SubNav sub={sub} />
      </article>
      <TableComponent
        errorMsg={error}
        success={success}
        subId={sub.id}
        saveStatus={saveStatus}
        onSubmit={onSubmitVoice}
        onSubmitSMS={onSubmitSMS}
        onSubmitVoice={onSubmitVoice}
      />
      <br />
      {success && <Link to={redirectionLink}>Go to subs page</Link>}
    </div>
  );
};

export default VoiceAndSMSRecords;
